<app-header-navbar
  [actionLabel]="actionLabel()"
  [actionLink]="actionLink()"
  [actionHidden]="!showAllProjectsAction()"
/>
<div>
  <router-outlet />
</div>
